import { Base, createApp } from '@studiometa/js-toolkit';
import Reviews from './Reviews/index.js';
import Stories from './Stories/index.js';
import Gallery from './Gallery.js';
import Slider from './Slider/index.js';
import Tabs from './Tabs.js';
import ZoomedGallery from './ZoomedGallery.js';
import { Action, ScrollAnimationParent } from '@studiometa/ui';
import Share from './Share.js';
import NativeShare from './NativeShare.js';
import CompleteProductPanel from './CompleteProductPanel.js';
import StickyHeader from './StickyHeader.js';
import KachingBlock from './KachingBlock.js';
import Reassurance from './Reassurance.js';
import SwatchColor from './SwatchColor.js';
import Conseils from './Conseils.js';
import betterDocs from './betterDocsFAQ.js';
import AddToCartSticky from './AddToCartSticky.js';
import CopyLinkToClipboard from './CopyLinkToClipboard.js';
import NewsletterSticky from './NewsletterSticky.js';
import Facets from './Facets/index.js';
import ProductRecommendations from './ProductRecommendations.js';

class App extends Base {
  static config = {
    name: 'App',
    components: {
      Action,
      ScrollAnimationParent,
      Share,
      NativeShare,
      CopyLinkToClipboard,
      NewsletterSticky,
      '#stamped-main-widget': Reviews,
      Stories,
      'kaching-bundles-block': KachingBlock,
      '.block-swatch__color': SwatchColor,
      '.store-faq__wrapper': betterDocs,
      Gallery,
      Tabs,
      Slider,
      ZoomedGallery,
      CompleteProductPanel,
      ProductRecommendations,
      StickyHeader,
      Reassurance,
      Conseils,
      AddToCartSticky,
      Facets,
    },
  };

}

createApp(App, document.body);
